<template>
<div class="flex pwa__install cursor-pointer" :style="{
    backgroundColor: ThemeStore.loginPage.appBackgroundColor,
    color: ThemeStore.loginPage.appTextColor
}" v-if="!isRunningPwa && deferredPrompt" @click="install">
    <img :src="ThemeStore.loginPage.appIcon.url" alt="" v-if="ThemeStore.loginPage.appIcon && ThemeStore.loginPage.appIcon.url" class="pwa__install__logo">
    <div class="pwa__install__label flex  items-center w-full">Installer l'application</div>
</div>
</template>
<script>
import { useThemeStore } from "@/store/ThemeStore";
export default {
    data() {
        const ThemeStore = useThemeStore();   

        return {
            ThemeStore: ThemeStore,
            deferredPrompt: null
        }
    },
    computed: {
        isRunningPwa: function() {
            return window.matchMedia('(display-mode: standalone)').matches;
        }
    },
    mounted() {
        window.addEventListener("beforeinstallprompt", e => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;
        });
    },
    methods: {
        async dismiss() {
            this.deferredPrompt = null;
        },
        async install() {
            this.deferredPrompt.prompt();
        }
    }
}
</script>